import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMinne = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Minner_logo",
		"data-name": "Minner logo",
		transform: "translate(-743.7 -232)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "M",
			d: "M24,16.1H19.513V6.019a4.316,4.316,0,0,0-.139-1.163,2,2,0,0,0-.418-.8,1.7,1.7,0,0,0-.77-.466,4.022,4.022,0,0,0-1.2-.155,3.62,3.62,0,0,0-.928.113,2.678,2.678,0,0,0-.774.34,2.62,2.62,0,0,0-.619.566,3.431,3.431,0,0,0-.464.793L14.22,16.1H9.749V6.034a4.328,4.328,0,0,0-.143-1.183,1.954,1.954,0,0,0-.429-.8,1.759,1.759,0,0,0-.774-.46,3.966,3.966,0,0,0-1.176-.153,4.014,4.014,0,0,0-.886.093,2.963,2.963,0,0,0-.754.279,2.68,2.68,0,0,0-.623.466,3.1,3.1,0,0,0-.491.652V9.854H0V.292H4.193L4.333,2.06a5.971,5.971,0,0,1,.968-.9A5.619,5.619,0,0,1,6.426.515,6.186,6.186,0,0,1,7.707.129,7.756,7.756,0,0,1,9.145,0a6.941,6.941,0,0,1,1.49.151A4.73,4.73,0,0,1,11.872.6a3.946,3.946,0,0,1,.984.753,4.374,4.374,0,0,1,.73,1.055,6.079,6.079,0,0,1,.976-1.055A5.461,5.461,0,0,1,15.725.6,5.926,5.926,0,0,1,17.076.151,7.562,7.562,0,0,1,18.615,0,8.234,8.234,0,0,1,19.89.094a5.786,5.786,0,0,1,1.1.281,4.422,4.422,0,0,1,.927.468,3.93,3.93,0,0,1,.752.655,4.333,4.333,0,0,1,.582.843,5.543,5.543,0,0,1,.416,1.032,7.78,7.78,0,0,1,.25,1.221A11.319,11.319,0,0,1,24,6V16.1Z",
			transform: "translate(743.679 235.766)",
			strokeMiterlimit: 10,
			strokeWidth: 1
		}), /* @__PURE__ */ _jsx("rect", {
			id: "Dot",
			width: 4.61,
			height: 3.525,
			transform: "translate(743.766 248.303)"
		})]
	})
});
export default SvgIconMinne;
